document.addEventListener('DOMContentLoaded', function () {

  // typewriter section 
const typeWriterSections = document.querySelectorAll(".type_writer_text");

  typeWriterSections.forEach(section => {
    const animatedTextAttribute = section.querySelector("[data-animated-text]").getAttribute("data-animated-text");
    const animatedText = animatedTextAttribute.split(", ").map(text => text.trim());
    
    const textElement = section.querySelector(".animated-text");
    let textIndex = 0;
    let charIndex = 0;

    function typeWriter() {
      if (charIndex < animatedText[textIndex].length) {
        textElement.textContent += animatedText[textIndex].charAt(charIndex);
        charIndex++;
        setTimeout(typeWriter, 100); 
      } else {
        setTimeout(eraseText, 2000); 
      }
    }

    function eraseText() {
      if (charIndex > 0) {
        textElement.textContent = animatedText[textIndex].substring(0, charIndex - 1);
        charIndex--;
        setTimeout(eraseText, 50);
      } else {
        textIndex = (textIndex + 1) % animatedText.length;
        setTimeout(typeWriter, 500); 
      }
    }
    typeWriter();
  });

  // scroll animations 
  gsap.registerPlugin(ScrollTrigger);

let tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".section__top",
    start: "top 20%",
    toggleActions: "play none none none"
  }
});

  tl.fromTo(".about_flower",
  {
    y: "0px"  
  },
  {
    y: "-15px", 
    duration: 1.5,
    ease: "power2.out"
  },
  0 
);

tl.to(".about_flower", {
  y: "-30px", 
  duration: 1.5,
  ease: "power1.inOut",
  repeat: -1,
  yoyo: true
}, "+=0");

tl.to(".pillow", {
  x: "-15px",
  duration: 1.5,
  ease: "power1.inOut",
  repeat: -1,
  yoyo: true
}, 0) 

tl.fromTo(".flower",
  {
    y: "0%"  
  },
  {
    y: "-15px", 
    duration: 1.5,
    ease: "power2.out"
  },
  0 
);

tl.to(".flower", {
  y: "-30px", 
  duration: 1.5,
  ease: "power1.inOut",
  repeat: -1,
  yoyo: true
}, "+=0");

  
  //  gsap.from(".element.tin-box", {
  //   y: "-50%",           
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".section__top",
  //     start: "top 20%",
  //     toggleActions: "play none none none"
  //   }
  // });
  
  // gsap.from(".element.chocolate", {
  //   x: "80%",           
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".section__top",
  //     start: "top 20%",
  //     toggleActions: "play none none none"
  //   }
  // });
  //   gsap.from(".pserson_img--left", {
  //   x: "-30vw",           
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".section__top",
  //     start: "top 20%",
  //     toggleActions: "play none none none"
  //   }
  // });
  //   gsap.from(".pserson_img--right", {
  //   x: "30vw",           
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".section__top",
  //     start: "top 20%",
  //     toggleActions: "play none none none"
  //   }
  // });
  
// gsap.from(".element.bunny-text", {
//     scale: 0.5,           
//     duration: 1.5,
//     ease: "power2.out",
//     scrollTrigger: {
//       trigger: ".section__top",
//       start: "top 20%",
//       toggleActions: "play none none none"
//     }
//   });
  
// 2nd section animation 

gsap.to(".horse_img", {
  rotation: 3,             
  duration: 1.5,            
  ease: "power1.inOut",         
  repeat: -1,                   
  yoyo: true,            
  scrollTrigger: {
    trigger: ".home_section2_wrapper",
    start: "top 50%",
    toggleActions: "play none none none"
  }
});
 gsap.from(".decorative_img", {
    y: "-15px",
    duration: 1.5, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".decorative_img",
        start: "top 80%",
        toggleActions: "play none none none"
    }
});
  
//  gsap.from(".clock_img", {
//     rotation: -45, 
//     duration: 1.5, 
//     ease: "power2.out",
//     paused: true, 
//     scrollTrigger: {
//         trigger: ".clock_img",
//         start: "top 80%",
//         toggleActions: "play none none none"
//     }
// });

// const chocoAnimationInfinite = gsap.from(".home_section2_wrapper .choc_bite_img", {
//   x: "100%",
//   duration: 1.5,
//   ease: "power2.out",
//   paused: true,
//   scrollTrigger: {
//     trigger: ".home_section2_wrapper",
//     start: "top 40%",
//     toggleActions: "play none none none"
//   },
//   onComplete: () => {
//     gsap.to(".home_section2_wrapper .choc_bite_img", {
//       x: "15px",
//       duration: 1.5,
//       ease: "power1.inOut",
//       repeat: -1,
//       yoyo: true
//     });
//   }
// });

if (window.innerWidth > 768) {
  gsap.to(".mushroom_img", {
    y: "100%",
    duration: 1.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".home_section-2",
      start: "top 40%",
      toggleActions: "play none none none"
    }
  });
}

  gsap.to(".cloud_box", {
  x: "35px",                   
  duration: 1.5,
  ease: "power1.inOut",         
  repeat: -1,                   
  yoyo: true,            
  scrollTrigger: {
    trigger: ".home_section2_wrapper",
    start: "top 50%",
    toggleActions: "play none none none"
  }
});
  gsap.to(".cloud_img", {
  x: "35px",                   
  duration: 1.5,
  ease: "power1.inOut",         
  repeat: -1,                   
  yoyo: true,            
  scrollTrigger: {
    trigger: ".home_section2_wrapper",
    start: "top 50%",
    toggleActions: "play none none none"
  }
});
    gsap.to(".sec3_lip_img", {
  y: "-15px",                   
  duration: 1.5,
  ease: "power1.inOut",         
  repeat: -1,                   
  yoyo: true,            
  scrollTrigger: {
    trigger: ".home_section3_wrapper",
    start: "top 50%",
    toggleActions: "play none none none"
  }
});
gsap.to(".sec3_dec_img", {
  x: "15px",
  duration: 1.5,
  delay: 0.3,
  ease: "power1.inOut",         
  repeat: -1,                   
  yoyo: true,            
  scrollTrigger: {
    trigger: ".home_section3_wrapper",
    start: "top 50%",
    toggleActions: "play none none none"
  }
});


  // section 3 animation 
  
gsap.to(".sec3_choco_img", {
    y: "200%", 
    duration: 1.5, 
    ease: "power2.out",
    paused: true, 
    scrollTrigger: {
        trigger: ".choco_box_container",
        start: "top 50%",
        toggleActions: "play none none none"
    }
});
  
gsap.to(".sec3_choco_img", {
  y: "130%", 
  duration: 1.5, 
  ease: "power2.out",
  paused: true, 
  scrollTrigger: {
      trigger: ".choco_box_container",
      start: "0 50%",
      onEnter: () => gsap.to(".sec3_choco_img", { y: "130%", duration: 1.5, ease: "power2.out" }),
      onLeaveBack: () => gsap.to(".sec3_choco_img", { y: "0%", duration: 2, ease: "power2.out" }) 
  }
});

  gsap.from(".exclusive_media", {
  y: "-84%",        
  opacity: 0,       
  duration: 1.5,
  ease: "power2.out",
  stagger: 0.2, 
  scrollTrigger: {
    trigger: ".exclusive_media__wrapper",
    start: "top 80%",
    toggleActions: "play none none none"
  }
});
   gsap.from(".exclusive_btm_img", {
    y: "-100%", 
    duration: 2.5, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".exclusive_media",
        start: "top 25%", 
        toggleActions: "play none none none" 
    }
});

    gsap.from(".about_media", {
  y: "-84%",        
  opacity: 0,       
  duration: 1.5,
  ease: "power2.out",
  stagger: 0.2, 
  scrollTrigger: {
    trigger: ".about_media__wrapper",
    start: "top 80%",
    toggleActions: "play none none none"
  }
});
   gsap.from(".about_btm_img", {
    y: "-100%", 
    duration: 2, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".about_media",
        start: "top 35%", 
        toggleActions: "play none none none" 
    }
});
gsap.from(".founder_media", {
    y: "-70%", 
    duration: 1.5, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".founder_bottom_img",
        start: "top 100%", 
        toggleActions: "play none none none" 
    }
});
  
gsap.from(".left_img", {
    y: "-30%", 
    duration: 1.5, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".two-image-features",
        start: "top 100%", 
        toggleActions: "play none none none" 
    }
});

gsap.from(".right", {
    y: "-30%", 
    duration: 1.5, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".two-image-features",
        start: "top 100%", 
        toggleActions: "play none none none" 
    }
});
gsap.from(".chocolate-image", {
    y: "80%", 
    duration: 2, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".images",
        start: "top 100%", 
        toggleActions: "play none none none" 
    }
});
gsap.from(".right-bottom", {
    y: "-80%", 
    duration: 2, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".image-box",
        start: "top 100%", 
        toggleActions: "play none none none" 
    }
});
gsap.from(".red_strip", {
    y: "-60%", 
    duration: 2, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".image-box ",
        start: "top 100%", 
        toggleActions: "play none none none" 
    }
});
  gsap.from("footer_scroll .fixed__media", {
    y: "-80%", 
    duration: 2, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".shopify-section-group-footer-group",
        start: "top 100%", 
        toggleActions: "play none none none" 
    }
});
  gsap.from(".prodpage_scroll .fixed__media", {
    y: "-80%", 
    duration: 2, 
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".prodpage_scroll",
        start: "top 100%", 
        toggleActions: "play none none none" 
    }
});
//   gsap.from(".product-image", {
//   y: "-50%", 
//   duration: 2, 
//   ease: "power2.out",
//   scrollTrigger: {
//       trigger: ".custom-product-container",
//       start: "top 100%", 
//       toggleActions: "play none none none" 
//   }
// });
gsap.from(".icon_fall", {
  y: "-40%",        
  opacity: 0,       
  duration: 1.5,
  ease: "power2.out",
  stagger: 0.2, 
  scrollTrigger: {
    trigger: ".content",
    start: "top 80%",
    toggleActions: "play none none none"
  }
});
  // tin box images animation 
        const images = document.querySelectorAll('.img__box_tin');
images.forEach((image) => {
    const moveRangeX = 50; 
    const moveRangeY = 50;
    let isDragging = false;
    let initialPosition = { x: 0, y: 0 }; 

    const movebalEl = image.closest('.img__box_tin--wrap');

    movebalEl.addEventListener('mousedown', () => {
        isDragging = true;
        initialPosition = { x: image._gsap.x, y: image._gsap.y }; 
        // gsap.set(image, { cursor: "grabbing" }); 
    });

    window.addEventListener('mouseup', () => {
        if (isDragging) {
            isDragging = false;
            // gsap.set(image, { cursor: "grab" });

            gsap.to(image, {
                x: initialPosition.x,
                y: initialPosition.y,
                duration: 0.3,
                ease: "power3.out"
            });
        }
    });

    movebalEl.addEventListener('mousemove', (event) => {
        if (!isDragging) return; 

        const containerRect = movebalEl.getBoundingClientRect();

        const mouseX = event.clientX - containerRect.left;
        const mouseY = event.clientY - containerRect.top;

        const xMovement = (mouseX / movebalEl.offsetWidth - 0.5) * 2;
        const yMovement = (mouseY / movebalEl.offsetHeight - 0.5) * 2;

        const xOffset = xMovement * moveRangeX;
        const yOffset = yMovement * moveRangeY;
        
        gsap.to(image, {
            x: xOffset,
            y: yOffset,
            duration: 0.3,
            ease: "power3.out"
        });
    });
});

  // featured product slider
  var swiper = new Swiper(".thumb_prod_slider", {
      spaceBetween: 30,
      slidesPerView: 3,
      freeMode: true,
      direction: "vertical",
      watchSlidesProgress: true,
      breakpoints: {
        0: {
          direction: "horizontal"
        },
        768: {
          direction: "vertical"
        }
      }
    });
    var swiper2 = new Swiper(".main_prod_slider", {
      spaceBetween: 0,
      effect: "fade",
      thumbs: {
        swiper: swiper,
      },
    });

  $('.my-slick-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    infinite: true,
    responsive: [
    {
      breakpoint: 1025, // target screens LESS than 1025px
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769, // target screens LESS than 769px
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });
  
document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".slider-mobile-gutter");
  if (sliderEl) {
    new Swiper(sliderEl, {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: '.custom-next',
        prevEl: '.custom-prev',
      },
    });
  }
});
 
  // custom cursor 
  const cursor = document.querySelector('.custom-cursor');
    if(cursor){
      document.addEventListener('mousemove', (event) => {
        gsap.to(cursor, {
          x: event.clientX,
          y: event.clientY,
          duration: 0.2, 
          ease: 'power3.out'
        });
      });
    }
    
});

